import * as React from 'react';

import { useGetState } from 'ahooks';
import { Flex, Form } from 'antd';

import { PrimitiveForm } from 'components';

import { ProductStatus, TreeSelectSource } from '../../../../types';
import { ProductsExportAction, ProductsImportAction } from './action';
import { ProductsReportFormContent } from './content';

export type FieldType = Partial<{
  searchKey: string;
  statuses: ProductStatus[];
  brandsIds: string[];
  categoriesIds: TreeSelectSource[];
  callForPrice: 'true' | 'false';
  isIndex: 'true' | 'false';
}>;

const ProductsReportForm = () => {
  const [form] = Form.useForm<FieldType>();
  const [durationRange, setDurationRange] = useGetState<[string?, string?]>([]);

  return (
    <Flex
      className='*:flex-1 first:*:rounded first:*:bg-white max-xl:flex-col xl:items-start xl:first:*:max-w-[70%] xl:last:*:max-w-[30%]'
      gap='large'
    >
      <PrimitiveForm form={form}>
        <ProductsReportFormContent setDurationRange={setDurationRange} />
      </PrimitiveForm>
      <Flex className='flex-col *:flex-1 *:rounded *:bg-white' gap='large'>
        <ProductsExportAction form={form} durationRange={durationRange} />
        <ProductsImportAction />
      </Flex>
    </Flex>
  );
};

export { ProductsReportForm };
